import request from '../../request'
import {checkin} from '../../endpoints'

export default class checkinApi {
  static async CheckInAvailableForPupil(schoolId, matId, pupilId) {
    return request({
      url: checkin.CheckInAvailableForPupil(schoolId, matId, pupilId),
      method: 'GET',
    })
  }
  static async GetCheckInForPupil(schoolId, matId, pupilId) {
    return request({
      url: checkin.getCheckInForPupil(schoolId, matId, pupilId),
      method: 'GET',
    })
  }
}
